import React, {
  useState,
  useEffect
} from 'react';
import axios from "axios";
import {
  getEmployerApplications,
  updateApplicationStatus,
  markApplicationViewed
} from '../services/applicationService';
import {
  sendConversationMessage
} from '../services/messageService';

import {
  getMessagesForApplication
} from '../services/messageService';

import './EmployerApplications.css';

export default function EmployerApplications() {

  const [statusFilter, setStatusFilter] =
    useState('All');

  const [applications, setApplications] =
  useState([]);

  const [loading, setLoading] =
  useState(true);

  const [selectedResume,
  setSelectedResume] =
  useState(null);

  const [emailModalOpen,
  setEmailModalOpen] =
  useState(false);

  const [emailSubject,
    setEmailSubject] =
    useState('');

  const [emailMessage,
    setEmailMessage] =
    useState('');

  const [emailStatus,
    setEmailStatus] =
    useState('');

  const [selectedApplication,
    setSelectedApplication] =
    useState(null);

  const [sendingEmail,
    setSendingEmail] =
    useState(false);

  const filteredApplications =
    statusFilter === 'All'
      ? applications
      : applications.filter(
          application =>
            application.status === statusFilter
        );
  const [ conversationOpen, setConversationOpen ] = useState(false);

  const [
    conversationMessages,
    setConversationMessages
  ] = useState([]);

  const [
    newMessage,
    setNewMessage
  ] = useState('');

  const [
    sendingMessage,
    setSendingMessage
  ] = useState(false);

  const sendEmployerMessage =
    async () => {

      if (!newMessage.trim()) {
        return;
      }

      try {

        setSendingMessage(true);

        await sendConversationMessage({
          application: selectedApplication,
          senderType: 'employer',
          body: newMessage.trim()
        });

        const messages =
          await getMessagesForApplication(
            selectedApplication.id
          );

        setConversationMessages(messages);
        setNewMessage('');

      } catch (error) {

        console.error(error);

        alert(
          'Unable to send message.'
        );

      } finally {

        setSendingMessage(false);

      }

    };

const openConversation =
  async (application) => {

    setSelectedApplication(
      application
    );

    const messages =
        await getMessagesForApplication(
          application.id
        );

      setConversationMessages(
        messages
      );

      setConversationOpen(true);

    };
  useEffect(() => {

    loadApplications();

  }, []);

  const loadApplications =
    async () => {

      try {

        setLoading(true);

        const results =
          await getEmployerApplications();

        setApplications(results);

      } catch (error) {

        console.error(
          'Unable to load applications:',
          error
        );

      } finally {

        setLoading(false);

      }

    };

  const getEmailTemplate = (
    application,
    action
  ) => {

    const name =
      `${application.firstName} ${application.lastName}`;

    const company =
      application.company;

    const job =
      application.jobTitle;

    switch (action) {

      case 'Interview Requested':

        return {

          subject:
            `Interview Invitation - ${job}`,

          message:
  `Hello ${name},

  Thank you for applying for the ${job} position with ${company}.

  We were impressed by your qualifications and would like to invite you to participate in an interview.

  Please log in to your Job Bank account to confirm your availability and continue the conversation.

  We look forward to speaking with you.

  Kind regards,

  ${company}`

        };

      case 'Rejected':

        return {

          subject:
            `Application Update - ${job}`,

          message:
  `Hello ${name},

  Thank you for your interest in the ${job} position.

  After careful consideration, we have decided to move forward with another candidate.

  We appreciate your interest and wish you every success in your job search.

  Kind regards,

  ${company}`

        };

      case 'Hired':

        return {

          subject:
            `Employment Offer - ${job}`,

          message:
  `Hello ${name},

  Congratulations.

  We are pleased to inform you that you have been selected for the ${job} position.

  We will contact you shortly regarding next steps and onboarding.

  We look forward to working with you.

  Kind regards,

  ${company}`

        };

      default:
        return {
          subject: '',
          message: ''
        };
    }

  };

  const openEmailModal = (
    application,
    status
  ) => {

    const template =
      getEmailTemplate(
        application,
        status
      );

    setSelectedApplication(
      application
    );

    setEmailStatus(
      status
    );

    setEmailSubject(
      template.subject
    );

    setEmailMessage(
      template.message
    );

    setEmailModalOpen(
      true
    );

  };

  if (loading) {

    return (

      <div className="employerApplications">

        <h2>
          Loading Applications...
        </h2>

      </div>

    );

  }

  const handleViewResume =
    async (application) => {

      if (!application.viewed) {

        await markApplicationViewed(
          application.id
        );

        await loadApplications();

      }

      setSelectedResume(
        {
          ...application,
          viewed: true
        }
      );

    };

    const sendStatusEmail =
      async () => {

        try {

          setSendingEmail(true);
          
          await sendConversationMessage({

            application: selectedApplication,

            senderType: 'employer',

            body: emailMessage

          });

          await axios.post(

            'https://fluency.ispeakwell.ca/api/application-email',

            {

              applicationId:
                selectedApplication.id,

              candidateEmail:
                selectedApplication.email,

              candidateName:
                `${selectedApplication.firstName}
                ${selectedApplication.lastName}`,

              subject:
                emailSubject,

              message:
                emailMessage

            }

          );

          await updateApplicationStatus(

            selectedApplication.id,

            emailStatus

          );

          await loadApplications();

          setEmailModalOpen(false);

        } catch (error) {

          console.error(error);

          alert(
            'Unable to send email.'
          );

        } finally {

          setSendingEmail(false);

        }

      };

      function formatTimestamp(value) {

        if (!value) {
          return '';
        }

        const date =
          value?.toDate
            ? value.toDate()
            : new Date(value);

        if (isNaN(date.getTime())) {
          return '';
        }

        return date.toLocaleString([], {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });

      }

  return (

    <div className="employerApplications">

      <div className="applicationsPanel">

        <div className="applicationsHeader">

          <div>

            <h1>
              Applications
            </h1>

            <p>
              Review resumes and manage
              candidate applications.
            </p>

          </div>

        </div>

        <div className="applicationStats">

          <div className="applicationStatCard">

            <span className="applicationStatNumber">
              {applications.length}
            </span>

            <span className="applicationStatLabel">
              Applications
            </span>

          </div>

          <div className="applicationStatCard">

            <span className="applicationStatNumber">
              {
                applications.filter(
                  app =>
                    app.viewed === true
                ).length
              }
            </span>

            <span className="applicationStatLabel">
              Viewed
            </span>

          </div>

          <div className="applicationStatCard">

            <span className="applicationStatNumber">
              {
                applications.filter(
                  app =>
                    app.status ===
                    'Interview Requested'
                ).length
              }
            </span>

            <span className="applicationStatLabel">
              Interviews
            </span>

          </div>

          <div className="applicationStatCard">

            <span className="applicationStatNumber">
              {
                applications.filter(
                  app =>
                    app.status === 'Hired'
                ).length
              }
            </span>

            <span className="applicationStatLabel">
              Hired
            </span>

          </div>

        </div>

        <div className="applicationToolbar">

          <button
            onClick={loadApplications}
          >
            Refresh
          </button>

          <select
            value={statusFilter}
            onChange={(e) =>
              setStatusFilter(
                e.target.value
              )
            }
          >

            <option>
              All
            </option>

            <option>
              Applied
            </option>

            <option>
              Interview Requested
            </option>

            <option>
              Rejected
            </option>

            <option>
              Hired
            </option>

          </select>

        </div>

        {
          filteredApplications.length === 0
            ? (

              <div className="emptyApplications">

                <div className="emptyApplicationsIcon">
                  📄
                </div>

                <h2>
                  No Applications Yet
                </h2>

                <p>
                  When candidates apply
                  to your jobs, their
                  resumes will appear here.
                </p>

              </div>

            )
            : (

              <div className="applicationsList">

                {
                  filteredApplications.map(
                    application => (

                      <div
                        className="applicationCard"
                        key={application.id}
                      >

                        <div className="applicationHeader">

                          <div>

                            <h3>
                              {
                                application.firstName
                              }{' '}
                              {
                                application.lastName
                              }
                            </h3>

                            <p>
                              {
                                application.jobTitle
                              }
                            </p>

                          </div>

                          <span
                            className={`applicationStatus ${application.status}`}
                          >
                            {
                              application.status
                            }
                          </span>

                        </div>

                        <div className="applicationDetails">

                          <div>

                            <strong>
                              Applied
                            </strong>

                            <p>
                              {
                                application.appliedAt?.toDate
                                  ? application
                                      .appliedAt
                                      .toDate()
                                      .toLocaleDateString()
                                  : 'Unknown'
                              }
                            </p>

                          </div>

                          <div>

                            <strong>
                              Email
                            </strong>

                            <p>
                              {
                                application.email
                              }
                            </p>

                          </div>

                        </div>

                        <div className="applicationActions">
                          <button
                            onClick={() =>
                              handleViewResume(
                                application
                              )
                            }
                          >
                            View Resume
                          </button>

                          <button
                            onClick={() =>
                              openEmailModal(
                                application,
                                'Interview Requested'
                              )
                            }
                          >
                            {
                              application.status ===
                              'Interview Requested'
                                ? 'Remove Interview'
                                : 'Interview'
                            }
                          </button>

                          <button
                            onClick={() =>
                              openEmailModal(
                                application,
                                'Rejected'
                              )
                            }
                          >
                            {
                              application.status ===
                              'Rejected'
                                ? 'Undo Reject'
                                : 'Reject'
                            }
                          </button>

                          <button
                            onClick={() =>
                              openEmailModal(
                                application,
                                'Hired'
                              )
                            }
                          >
                            {
                              application.status ===
                              'Hired'
                                ? 'Undo Hire'
                                : 'Hire'
                            }
                          </button>
                          <button
                            onClick={() =>
                              openConversation(application)
                            }
                          >
                            Messages
                          </button>
                        </div>

                      </div>

                    )
                  )
                }

              </div>

            )
        }
        {
          selectedResume && (

            <div
              className="resumeModalOverlay"
              onClick={() =>
                setSelectedResume(null)
              }
            >

              <div
                className="resumeModal"
                onClick={(e) =>
                  e.stopPropagation()
                }
              >

                <div
                  className="resumeModalHeader"
                >

                  <h2>
                    Resume
                  </h2>

                  <button
                    onClick={() =>
                      setSelectedResume(null)
                    }
                  >
                    ✕
                  </button>

                </div>

                <h3>
                  {
                    selectedResume.firstName
                  }{' '}
                  {
                    selectedResume.lastName
                  }
                </h3>

                <pre
                  className="resumeContent"
                >
                  {
                    selectedResume.resumeText
                  }
                </pre>

              </div>

            </div>

          )
        }
      </div>
      {
        emailModalOpen && (

          <div
            className="emailModalOverlay"
          >

            <div
              className="emailModal"
            >

              <h2>
                Send Email
              </h2>

              <input
                value={emailSubject}
                onChange={(e) =>
                  setEmailSubject(
                    e.target.value
                  )
                }
                placeholder="Subject"
              />

              <textarea
                value={emailMessage}
                onChange={(e) =>
                  setEmailMessage(
                    e.target.value
                  )
                }
              />

              <div
                className="emailModalActions"
              >

                <button
                  onClick={() =>
                    setEmailModalOpen(
                      false
                    )
                  }
                >
                  Cancel
                </button>

                <button
                  onClick={
                    sendStatusEmail
                  }
                  disabled={
                    sendingEmail
                  }
                >

                  {
                    sendingEmail
                      ? 'Sending...'
                      : 'Send Email'
                  }

                </button>

              </div>

            </div>

          </div>

        )
      }
      {
        conversationOpen && (

          <div className="emailModalOverlay">

            <div className="emailModal conversationModal">

              <h2>
                Conversation
              </h2>

              <div className="conversationMessages">

                {
                  conversationMessages.map(
                    message => (

                      <div
                        key={message.id}
                        className={`messageBubble ${message.senderType}`}
                      >

                        <div className="messageSender">

                          {
                            message.senderType === 'candidate'
                              ? `${selectedApplication.firstName} ${selectedApplication.lastName}`
                              : message.senderType === 'employer'
                                ? 'You'
                                : 'System'
                          }

                        </div>

                        <div className="messageText">

                          {message.body}

                        </div>
                        <div className="messageTime">
                          {formatTimestamp(message.createdAt)}
                        </div>

                      </div>

                    )
                  )
                }

              </div>
              <div className="conversationComposer">

                <textarea
                  value={newMessage}
                  onChange={(e) =>
                    setNewMessage(e.target.value)
                  }
                  placeholder="Type a message..."
                />

                <button
                  onClick={sendEmployerMessage}
                  disabled={
                    sendingMessage ||
                    !newMessage.trim()
                  }
                >
                  {
                    sendingMessage
                      ? 'Sending...'
                      : 'Send'
                  }
                </button>

              </div>
              <button
                onClick={() =>
                  setConversationOpen(false)
                }
              >
                Close
              </button>

            </div>

          </div>

        )
      }
    </div>

  );

}